const $sortInputs = document.querySelectorAll('.js-news-sort');

$sortInputs.forEach($input => {
    $input.addEventListener('change', () => {
        $input.closest('form').submit();
    })
});
